import type {PlantHierarchyNode} from '@hproduce/suite-core'

export const getCurrentLocation = (hierarchyId: string, plantHierarchy: PlantHierarchyNode[]) => {
  const flatTree = flatPlantHierarchyTree(plantHierarchy)
  return flatTree.get(hierarchyId)
}

function flatPlantHierarchyTree(nodes: PlantHierarchyNode[]): Map<string, string> {
  const map = new Map<string, string>()
  for (const node of nodes) {
    map.set(node.hierarchyId, node.name)
    if (node.children && node.children.length > 0) {
      const childMap = flatPlantHierarchyTree(node.children)
      for (const [key, value] of childMap.entries()) {
        map.set(key, value)
      }
    }
  }

  return map
}
